/** Resolve translated menu content (categories / products) for client display. */

export function pickMenuTranslation(translations, lang) {
    if (!translations || lang === 'ro') return {};
    const tr = translations[lang];
    return tr && typeof tr === 'object' ? tr : {};
}

export function localizeCategoryForMenu(category, lang) {
    if (!category || lang === 'ro') return category;
    const tr = pickMenuTranslation(category.translations, lang);
    const name = tr.name?.trim();
    if (!name) return category;
    return { ...category, name };
}

export function localizeProductForMenu(product, lang) {
    if (!product || lang === 'ro') return product;
    const tr = pickMenuTranslation(product.translations, lang);
    if (!Object.keys(tr).length) return product;

    const name = tr.name?.trim();
    const description = tr.description?.trim();
    const tags = Array.isArray(tr.tags) && tr.tags.length ? tr.tags.map((t) => String(t).trim()).filter(Boolean) : null;
    const ingredients = Array.isArray(tr.ingredients) && tr.ingredients.length
        ? tr.ingredients.map((i) => String(i).trim()).filter(Boolean)
        : null;
    const variantNames = tr.variants && typeof tr.variants === 'object' ? tr.variants : {};

    return {
        ...product,
        name: name || product.name,
        description: description || product.description,
        tags: tags || product.tags,
        ingredients: ingredients || product.ingredients,
        variants: (product.variants || []).map((variant) => {
            const translated = variantNames[variant.id]?.trim();
            return translated ? { ...variant, name: translated } : variant;
        }),
    };
}

export function localizeMenuCatalog(categories, products, lang) {
    return {
        categories: (categories || []).map((c) => localizeCategoryForMenu(c, lang)),
        products: (products || []).map((p) => localizeProductForMenu(p, lang)),
    };
}
